var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "weituo" }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          _c("i", {
            staticClass: "el-icon-box",
            staticStyle: { color: "#63b947", "font-size": "25px" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "tittype" }, [
            _vm._v(_vm._s(_vm.$t("i18n_product_information")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "goodsForm",
          staticClass: "small",
          attrs: {
            model: _vm.addGoodsForm,
            rules: _vm.goodsInfoFormRules,
            size: "small"
          }
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                border: "",
                data: _vm.addGoodsForm.GoodsList,
                "header-cell-style": { background: "#f6f6f6" }
              }
            },
            [
              _c("el-table-column", {
                attrs: { label: _vm.$t("i18n_product_name"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "GoodsList[" + scope.$index + "].goodsname",
                              rules: _vm.goodsInfoFormRules.goodsname
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "center",
                              model: {
                                value: scope.row.goodsname,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "goodsname", $$v)
                                },
                                expression: "scope.row.goodsname"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("i18n_brands"),
                  align: "center",
                  width: "60px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "GoodsList." + scope.$index + ".isBrand",
                              rules: _vm.goodsInfoFormRules.isBrand
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: scope.row.isBrand,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "isBrand", $$v)
                                  },
                                  expression: "scope.row.isBrand"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("i18n_yes")))]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("i18n_elestric"),
                  align: "center",
                  width: "60px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop:
                                "GoodsList." + scope.$index + ".isHasBattery",
                              rules: _vm.goodsInfoFormRules.isHasBattery
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: scope.row.isHasBattery,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "isHasBattery", $$v)
                                  },
                                  expression: "scope.row.isHasBattery"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("i18n_yes")))]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("i18n_liquid_powder"),
                  align: "center",
                  width: "60px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop:
                                "GoodsList." + scope.$index + ".isPowderLiquid",
                              rules: _vm.goodsInfoFormRules.isPowderLiquid
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: scope.row.isPowderLiquid,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "isPowderLiquid", $$v)
                                  },
                                  expression: "scope.row.isPowderLiquid"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("i18n_yes")))]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("i18n_carton_count"),
                  align: "center",
                  width: "80px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "GoodsList." + scope.$index + ".boxNum",
                              rules: _vm.goodsInfoFormRules.boxNum
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              model: {
                                value: scope.row.boxNum,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "boxNum", $$v)
                                },
                                expression: "scope.row.boxNum"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { label: _vm.$t("i18n_single_box"), align: "center" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("i18n_pcs_count"),
                      align: "center",
                      width: "80px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "GoodsList." + scope.$index + ".piece",
                                  rules: _vm.goodsInfoFormRules.piece
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: scope.row.piece,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "piece", $$v)
                                    },
                                    expression: "scope.row.piece"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("i18n_weight_kgs"),
                      align: "center",
                      width: "80px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "GoodsList." + scope.$index + ".weight",
                                  rules: _vm.goodsInfoFormRules.weight
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: scope.row.weight,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "weight", $$v)
                                    },
                                    expression: "scope.row.weight"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("i18n_length"),
                      align: "center",
                      width: "80px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "GoodsList." + scope.$index + ".l",
                                  rules: _vm.goodsInfoFormRules.l
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: scope.row.l,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "l", $$v)
                                    },
                                    expression: "scope.row.l"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("i18n_wide"),
                      align: "center",
                      width: "80px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "GoodsList." + scope.$index + ".w",
                                  rules: _vm.goodsInfoFormRules.w
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: scope.row.w,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "w", $$v)
                                    },
                                    expression: "scope.row.w"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("i18n_height"),
                      align: "center",
                      width: "80px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "GoodsList." + scope.$index + ".h",
                                  rules: _vm.goodsInfoFormRules.h
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: scope.row.h,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "h", $$v)
                                    },
                                    expression: "scope.row.h"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("i18n_label"),
                  align: "center",
                  width: "100px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "GoodsList." + scope.$index + ".markno",
                              rules: _vm.goodsInfoFormRules.markno
                            }
                          },
                          [
                            _c("el-autocomplete", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "fetch-suggestions": _vm.filterMarknoList
                              },
                              model: {
                                value: scope.row.markno,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "markno", $$v)
                                },
                                expression: "scope.row.markno"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: _vm.$t("i18n_Operation"),
                    align: "center",
                    width: "80px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "medium" },
                      on: { click: _vm.addItem }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_add_product")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: {
            border: "",
            data: _vm.goodsInfoForm.GoodsList,
            "header-cell-style": { background: "#f6f6f6" },
            "summary-method": _vm.getSummaries,
            "show-summary": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_Serial_number"),
              type: "index",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_product_name"),
              prop: "goodsname",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_product_type"),
              prop: "goodsTypeName",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_brands"),
              align: "center",
              width: "50px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(scope.row.isBrand ? "i18n_yes" : "i18n_no")
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_elestric"),
              align: "center",
              width: "50px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            scope.row.isHasBattery ? "i18n_yes" : "i18n_no"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_liquid_powder"),
              align: "center",
              width: "60px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            scope.row.isPowderLiquid ? "i18n_yes" : "i18n_no"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_carton_count"),
              prop: "boxNum",
              align: "center",
              width: "50px"
            }
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: _vm.$t("i18n_single_box"), align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("i18n_pcs_count"),
                  prop: "piece",
                  align: "center",
                  width: "50px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("i18n_weight_kgs"),
                  prop: "weight",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: _vm.$t("i18n_lwh"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.l) +
                            "×" +
                            _vm._s(scope.row.w) +
                            "×" +
                            _vm._s(scope.row.h) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("i18n_volume"),
                  prop: "cbm",
                  align: "center"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_label"),
              prop: "markno",
              align: "center",
              width: "60px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_total_weight"),
              prop: "totalweight",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_total_volume"),
              prop: "totalcbm",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("i18n_Operation"),
              align: "center",
              width: "100px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.del(scope.$index)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_delete")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.edit(scope.$index)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a7666fcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7666fcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/placeOrder/component/goodsInfo.vue
// module id = null
// module chunks = 